import { RIGHTPANEL } from "../../actions/dashboard/";

export default function(state = false, action){
  switch (action.type) {
    case RIGHTPANEL:
    return action.payload;
    default:
  }

  return state;
}
